export const MODAL_SHOW = "MODAL_SHOW";
export const MODAL_HIDE = "MODAL_HIDE";

const initialState = {
  openModal: false
};

export default function modalReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case MODAL_SHOW:
      return payload;

    case MODAL_HIDE:
      return payload;

    default:
      return state;
  }
}

export function showModal() {
  return {
    type: MODAL_SHOW,
    payload: {
      openModal: true
    }
  };
}

export function hideModal() {
  return {
    type: MODAL_HIDE,
    payload: {
      openModal: false
    }
  };
}
